import { RegisterCompanyInfoMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const registerCompanyInfoHandler =
  graphql.mutation<RegisterCompanyInfoMutation>(
    "registerCompanyInfo",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          registerCompanyInfo: {
            result: true,
          },
        },
        // Uncomment the following lines to test error handling
        // errors: [
        //   {
        //     extensions: {
        //       code: ErrorCode[
        //         ErrorCode.BANK_PORTAL_COMPANY_INFO_IS_ALREADY_REGISTERED_ERROR
        //       ],
        //     },
        //   },
        // ],
      });
    }
  );
